import { call, put } from 'redux-saga/effects';
import { appDataService } from '@flow/appsync-client';
import gql from 'graphql-tag';
import { addFavourite } from '@flow/graphql/mutations';
import { ADD_FAVOURITE_ERROR, ADD_FAVOURITE_SUCCESS } from '@flow/store/user/constants';

const ApiRequest = (favourite: Favourite) => {
  return appDataService.client.mutate({
    mutation: gql(addFavourite),
    variables: { favourite: favourite }
  });
};

export function * addFavouriteFlow(favourite: Favourite, onComplete?: (result: APICallResult) => any) {
  try {
    const response = yield call(ApiRequest, favourite);

    if (response) {
      yield put({ type: ADD_FAVOURITE_SUCCESS, data: response.data });

      if (onComplete) {
        onComplete({ data: response.data });
      }
    }
  } catch (error) {
    yield put({ type: ADD_FAVOURITE_ERROR, favourite });

    if (onComplete) {
      onComplete({ error });
    }
  }
  return true;
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/flows/add-favourite-flow.ts